import React,{useState,useEffect} from 'react';
import {Form,Col, Container} from 'react-bootstrap';
import clearParentState from "../../utilities/ClearParentState/clearstate"
import { TextInput } from './dropdowns/components';

function Treatment_input(props){
    const [inputDisabled,setInputDisabled] = useState(props.disabled?true:false)
    const [answer,setAnswer] = useState(props.data!=null?props.data[props.name]:"")
    const [dose,setDose] = useState(props.data!=null?props.data[props.name+'_dose']:"")
    const [date,setDate] = useState(props.data!=null?props.data[props.name+'_started']:"")
    const [side_effects,setSide_effects] = useState(props.data!=null?props.data[props.name+'_side_effects']:"")

    var answers = props.answers;
    if (answers === undefined){
         answers = ['','Yes','No','N/A']

    }


    useEffect(()=>{
        if(props.data==null){
            setInputDisabled(true)
            
        }
    },[])

    useEffect(()=>{ // Checking if answer switched from yes to no.If yes then clear parent state 
        if(answer ==='No' && props.data== null){
           var dose_clear = clearParentState(props.name+'_dose')
           var date_clear = clearParentState(props.name+'_started')
           var side_effects_clear = clearParentState(props.name+'_side_effects')
           props.handler('current_treatment',dose_clear)
           props.handler('current_treatment',date_clear)
           props.handler('current_treatment',side_effects_clear)
           
        }
    },[answer])
    useEffect(()=>{
        if(!props.disabled && answer ==='Yes'){
            setInputDisabled(false)
        }
    },[props.disabled])
    const  handleChange = (event) =>{
        if(event.target.value ==='No' || event.target.value ==='N/A'){
            setInputDisabled(true)
            setDose("")
            setDate("")
            setSide_effects("")
            let clear = {}
            clear.name = props.name
        }
        else if(inputDisabled){
            setInputDisabled(false)
        }
        setAnswer(event.target.value)
        props.handler('current_treatment',event);
    }
    const handleDoseChange = (event)=>{
        setDose(event.target.value)
        props.handler('current_treatment',event)
    }
    const handleDateChange = (event)=>{
        setDate(event.target.value)
        props.handler('current_treatment',event)
    }
    const handleSideEffectsChange = (event)=>{
        setSide_effects(event.target.value)
        props.handler('current_treatment',event)
    }
    
    return(
        <Form.Row>
            <Form.Group as={Col}>
                        <Form.Label>{props.title}</Form.Label>
                        <Form.Control as={"select"} name={props.name} onChange={handleChange} disabled={props.disabled && true} value={answer}>
                            {answers.map((answer,index)=>{
                                return( <option>{answer}</option>)
                            })}
                        </Form.Control>
            </Form.Group>
            <Form.Group as={Col}>
                        <Form.Label>How much?</Form.Label>
                        <Form.Control as={"input"} name={props.name+'_dose'} onChange={handleDoseChange} disabled={inputDisabled} value={dose}/>
            </Form.Group>
            <Form.Group as={Col}>
                        <Form.Label>Since when</Form.Label>
                        <Form.Control type={'date'} name={props.name+'_started'} onChange={handleDateChange} disabled={inputDisabled} value={date}/>
            </Form.Group>
            <Form.Group as={Col}>
                        <Form.Label>Side effects</Form.Label>
                        <Form.Control as={"select"} name={props.name+'_side_effects'} onChange={handleSideEffectsChange} disabled={inputDisabled} value={side_effects}>
                            <option></option>
                            <option>No</option>
                            <option>ocd</option>
                            <option>nausea</option>
                            <option>hypotension</option>
                            <option>hallucinations</option>
                            <option>other</option>
                        </Form.Control>
            </Form.Group>
        </Form.Row>
    )
}

function CurrentTreatment(props){
    const[otherDrugs,setOtherDrugs] = useState(props.data!=null? props.data['other_drugs']:"")
    const[otherDrugsSideEffects,setOtherDrugsSideEffects] = useState(props.data!=null? props.data['other_drugs_side_effects']:"")
    const handleTextBox = (e)=>{
        setOtherDrugs(e.target.value)
        props.handler('current_treatment',e)
    }
    const handleSideEffectsTextBox = (e)=>{
        setOtherDrugsSideEffects(e.target.value)
        props.handler('current_treatment',e)
    }
    return(
        <Container style={{"maxWidth":"1600px"}}>
            <h4>Current treatment</h4> 
            <Form>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Levodopa carbidopa/benzerazide ' name='levodopa_carbidopa_benzeraride' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='COMT-Inhibitors' name='comt_inhibitors' handler={props.handler} answers={['','Entacapone','Tolcapone','Opicapone','No']}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Dopamine agonists' name='dopamine_agonists' handler={props.handler} answers={['','Pramipexole', 'Rotigotine', 'Ropinirole', ]}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Pramipexole' name='Pramipexole' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Rotigotine' name='rotigotine' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Ropirinirole' name='ropirinirole' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='MAO-B inhibitors' name='mao_b_inhibitors' handler={props.handler} answers={['','Rasagiline','Selegiline','Safinamide','No']}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Rasagiline' name='rasagiline' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Selegiline' name='selegiline' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Amantadine' name='amantadine' handler={props.handler}/>

                <Treatment_input disabled ={props.disabled} data={props.data} title='Other dopaminergic medication' name='other_dopaminergic_mediaction' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Antidepressiva' name='antidepressiva' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data}title='SSRI' name='ssir' handler={props.handler}/>

                <Treatment_input disabled ={props.disabled} data={props.data} title='SNRI' name='snri' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Other antidepressants except SSRI and SNRI' name='other_antidepressants_except_ssri_snri' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Antidementiva' name='antidementiva' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='ACE-inhibitors' name='ace_inhibitors' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Memantin' name='memantin' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Other antidementiva except Ace-inhibitors and memantine' name='other_antidementiva_except_ace_inhibitors_memantine' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Physiotherapy' name='physiotherapy' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Speech therapy' name='speech_therapy' handler={props.handler}/>
                <Treatment_input disabled ={props.disabled} data={props.data} title='Anticholinergics' name='anticholinergics' handler={props.handler} answers={['','Trihexiphenidyl', 'Biperiden', 'Orphenadrine', 'No']}/>

               
                <Form.Group>
                    <Form.Label>Other Drugs </Form.Label>
                    <Form.Control as={'textarea'} name={'other_drugs'} value={otherDrugs}onChange={handleTextBox} disabled={props.disabled}/>
                </Form.Group>
                <Form.Group>
                    <Form.Label>Side effects </Form.Label>
                    <Form.Control as={'textarea'} name={'other_drugs_side_effects'} value={otherDrugsSideEffects}onChange={handleSideEffectsTextBox} disabled={props.disabled}/>
                </Form.Group>
                {/* <TextBox data={props.data!=null? props.data['other_drugs']:undefined} disabled={props.disabled} handler={props.handler}/> */}
                
            </Form>
        </Container>
    )
}
Treatment_input.defaultProps = {
    data:null
}
export default CurrentTreatment;